module.exports = __webpack_public_path__ + "static/img/10007 (1).732d71c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10007 (1).webp
// module id = fjnk
// module chunks = 14